export default "__VITE_ASSET__DMvODpvQ__"